/* Anemoia — "Ask about this piece".
   An editorial, on-brand ask affordance injected into the product buy-box, because the
   questions that decide a one-of-one sale (measurements, fit, condition) arise exactly there.

   Behaviour on a chip click:
     1. If the legacy Inbox composer (#ShopifyChat shadow DOM) is present, open + pre-fill it.
     2. Otherwise fall back to the contact page pre-filled with the question + the piece.
   The store's chat is now Shopify's <shopify-agent> (an AI assistant); we deliberately route
   Measurements/Enquire to the human contact form rather than the AI, so per-piece answers
   (measurements especially) always come from us and are never machine-guessed. Either way the
   question arrives WITH the piece attached, never as a context-free "hi". */
(function () {
  'use strict';

  var CHIPS = [
    { key: 'measurements', label: 'Measurements', q: 'Could you share the measurements for this piece?' },
    { key: 'enquire', label: 'Enquire', q: 'I have a question about this piece.' }
  ];

  function css() {
    if (document.getElementById('anemoia-ask-css')) return;
    var s = document.createElement('style');
    s.id = 'anemoia-ask-css';
    s.textContent = [
      '.aask{margin:22px 0 4px;padding-top:20px;border-top:1px solid rgba(31,23,19,.14);}',
      '.aask__label{display:flex;align-items:center;gap:9px;font-family:var(--font-body-family);font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:#8c6e4a;margin:0 0 14px;}',
      '.aask__dot{width:6px;height:6px;border-radius:50%;background:#8c6e4a;flex:none;}',
      '.aask__chips{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 12px;}',
      '.aask__chip{font-family:var(--font-body-family);font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#1f1713;background:none;border:1px solid rgba(31,23,19,.28);border-radius:0;padding:9px 14px;cursor:pointer;transition:background .2s,color .2s,border-color .2s;}',
      '.aask__chip:hover,.aask__chip:focus-visible{background:#1f1713;border-color:#1f1713;color:#f5f2ee;}',
      '.aask__note{font-family:var(--font-body-family);font-size:12.5px;line-height:1.6;color:#8a7d70;margin:0;}',
      '.aask__note em{font-style:italic;}',
      /* Mobile: chips become proper ~44px tap targets (the mobile-UI 44pt rule). */
      '@media (max-width:749px){ .aask__chips{gap:10px;} .aask__chip{padding:13px 18px;font-size:12px;} .aask__note{font-size:13px;} }'
    ].join('\n');
    document.head.appendChild(s);
  }

  function piece() {
    var path = location.pathname.split('/products/')[1] || '';
    var handle = path.split('?')[0].split('#')[0].replace(/\/$/, '');
    var t = document.querySelector('.product__title h1, h1.product__title, .product__title');
    var title = t ? (t.textContent || '').replace(/\s+/g, ' ').trim() : document.title;
    // collapse Dawn's occasional duplicated title node
    var dup = title.match(/^(.+?)\s*\1$/);
    if (dup) title = dup[1].trim();
    return { handle: handle, title: title, url: location.origin + '/products/' + handle };
  }

  /* Legacy Shopify Inbox launcher was <inbox-online-store-chat id="ShopifyChat"> with an OPEN shadow
     root and a textarea.composer-bar__message-text. Newer stores use <shopify-agent> instead, which
     is an AI assistant — we do NOT pre-fill that (see file header). So this only opens the classic
     Inbox composer when it exists; otherwise ask() falls through to the contact form. */
  function chatRoot() {
    var host = document.getElementById('ShopifyChat');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  // The composer is a framework-controlled input: assigning .value directly does NOT update its
  // internal state (the Send button would stay disabled). Go through the native setter and fire
  // an input event so it registers the text as if the visitor typed it.
  function setComposer(ta, text) {
    var setter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
    setter.call(ta, text);
    ta.dispatchEvent(new Event('input', { bubbles: true }));
    ta.dispatchEvent(new Event('change', { bubbles: true }));
    ta.focus();
  }

  function openChat(message) {
    var sr = chatRoot();
    if (!sr) return false;

    // Only toggle if it isn't already open — the composer only exists while open.
    if (!sr.querySelector('textarea.composer-bar__message-text')) {
      var toggle = sr.querySelector('button.chat-toggle') || sr.querySelector('button');
      if (!toggle) return false;
      toggle.click();
    }

    var tries = 0;
    (function fill() {
      var ta = sr.querySelector('textarea.composer-bar__message-text') || sr.querySelector('textarea');
      if (ta) {
        setComposer(ta, message);
        return;
      }
      if (tries++ < 40) setTimeout(fill, 120); // panel animates in; poll briefly
    })();
    return true;
  }

  function ask(chip) {
    var p = piece();
    // The question arrives WITH the piece attached, so it never lands as a context-free "hi".
    var msg = chip.q + '\n\nPiece: ' + p.title + '\n' + p.url;
    if (openChat(msg)) return;
    // No classic Inbox composer — fall back to the contact form, pre-filled the same way.
    location.href = '/pages/contact?ask=' + encodeURIComponent(msg);
  }

  function mountPdp() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.aask')) return;
    // Sit BELOW the buy button, never above it — Add to cart stays the primary action and the
    // ask block supports it. (The wishlist anchors itself to the price, which is higher up.)
    var anchor =
      document.querySelector('.product-form') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('.awl-notify, .awl-nform, .awl-nok') ||
      document.querySelector('.awl-pdp');
    if (!anchor) return;

    css();
    var box = document.createElement('div');
    box.className = 'aask';
    var chips = CHIPS.map(function (c) {
      return '<button type="button" class="aask__chip" data-aask="' + c.key + '">' + c.label + '</button>';
    }).join('');
    box.innerHTML =
      '<p class="aask__label"><span class="aask__dot"></span>Ask about this piece</p>' +
      '<div class="aask__chips">' + chips + '</div>' +
      '<p class="aask__note"><em>Here to assist, should any question arise.</em></p>';

    box.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-aask]');
      if (!b) return;
      var key = b.getAttribute('data-aask');
      for (var i = 0; i < CHIPS.length; i++) {
        if (CHIPS[i].key === key) {
          ask(CHIPS[i]);
          return;
        }
      }
    });

    anchor.parentNode.insertBefore(box, anchor.nextSibling);
  }

  // Contact page: honour the pre-filled question handed over by the fallback above.
  function prefillContact() {
    var q = new URLSearchParams(location.search).get('ask');
    if (!q) return;
    var body =
      document.querySelector('#ContactForm-body, textarea[name="contact[body]"], .contact textarea');
    if (!body) return;
    body.value = q;
    // Caret at the START so, when they tap in, they read the question first (not mid-text).
    try { body.setSelectionRange(0, 0); } catch (e) {}
    body.scrollTop = 0;

    // Bring the FORM's top (heading + name / email / message) into view — NOT the footer below it.
    // We deliberately do NOT auto-focus: on mobile, focusing scrolls the page down to the message
    // field near the form's bottom and reveals the footer — exactly the jump we're fixing.
    var form = body.closest('form') || body;
    function toTop() {
      var top = form.getBoundingClientRect().top + window.pageYOffset - 90; // clear the sticky header
      window.scrollTo(0, Math.max(0, top));
      body.scrollTop = 0;
    }
    toTop();
    setTimeout(toTop, 60);
    setTimeout(toTop, 240);
  }

  function boot() {
    mountPdp();
    prefillContact();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
